import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Selector } from "./Selector";

export const ObjectiveSelect = ({
  id = "objective-selector",
  selectedObjective,
  selectedGoal,
  selectedCycle,
  selectHandler,
  trigger,
  setTrigger,
  dashboardGoals,
  size,
}) => {
  const { t } = useTranslation();
  const [objectives, setObjectives] = useState([]);

  useEffect(() => {
    if (trigger) {
      setTrigger(false);
      const objectiveOptions = [];
      if (dashboardGoals) {
        dashboardGoals.forEach((goal) => {
          if (goal.id === selectedGoal) {
            goal.objectives.forEach((objective) => {
              objectiveOptions.push({
                id: objective.id === 0 ? "0" : objective.id,
                name: objective.description,
                label: objective.description,
              });
            });
          }
        });
      } else if (selectedGoal && selectedCycle) {
        selectedCycle.goals.forEach((goal) => {
          if (goal.id === selectedGoal) {
            goal.objectives.forEach((objective) => {
              objectiveOptions.push({
                id: objective.id,
                name: objective.description,
                label: objective.description,
              });
            });
          }
        });
        objectiveOptions.unshift({
          id: "0",
          name: t("cyclesAndGoals.cycleGoal.objectiveNoneName"),
          label: t("global.none"),
        });
      }
      setObjectives(objectiveOptions);
    }
  }, [selectedCycle, selectedGoal, selectedObjective, trigger]);

  return (
    <Selector
      id={id}
      size={size}
      label={t("cyclesAndGoals.objective")}
      assistiveText={t("cyclesAndGoals.cycleGoal.objectiveAssistiveText")}
      selectHandler={selectHandler}
      options={objectives ? objectives : []}
      selectedItemId={selectedObjective}
      clear={trigger}
    />
  );
};
